<template>
  <div class="cart__search">
    <label
      class="cart__search__label"
      for="product-search"
    >Etsi ja lisää tuote</label>
    <div
      v-click-outside="close"
      class="cart__search__input-container"
    >
      <input
        id="product-search"
        v-model="searchTerm"
        type="search"
        class="cart__search__input cart__search__input--with-icon cart__search__input--small small"
        autocomplete="new-password"
        placeholder="Etsi tuotetta"
        @keyup="dSearch()"
        @keydown.enter.prevent="search()"
        @focus="open()"
      >
      <ul
        v-if="searchResults.length > 0 && showSearchResults"
        class="cart__search__results"
      >
        <li
          v-for="(searchResult) in searchResults"
          :key="searchResult.id"
          class="cart__search__result"
          tabindex="0"
          @click="select(searchResult)"
        >
          <span class="cart__search__result-main">{{ searchResult.brand.name }} {{ searchResult.name }}</span>
          <span class="cart__search__result-detail">{{ searchResult.sku }}</span>
        </li>
      </ul>
      <div
        v-else-if="showSearchResults && searchTerm != '' && !loading"
        class="cart__search__results"
      >
        <div class="cart__search__no-results">
          Ei tuloksia
        </div>
      </div>

      <div
        v-else-if="showSearchResults && loading"
        class="cart__search__results"
      >
        <div class="cart__search__no-results">
          Ladataan...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import { EventBus } from '../../event-bus.js';
    import ClickOutside from 'vue-click-outside';
    import _ from 'lodash';

    export default {

        directives: {
            ClickOutside,
        },
        props: {
            nonce: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                searchTerm: '',
                showSearchResults: false,
                searchResults: [],
                loading: false,
            }
        },
        methods: {

            search() {
                let config = {
                    headers: {
                        'X-WP-Nonce': this.nonce,
                    },
                }

                this.loading = true;

                axios.get('/wp-json/modeo/v2/products/get?results=20&include_private_products=true&s=' + this.searchTerm, config)
                .then(response => {
                    this.searchResults = response.data.products;
                    this.showSearchResults = true;
                    this.loading = false;
                });

            },

            dSearch: _.debounce(function() {
                if (this.searchTerm != '') {
                    this.search();
                } else {
                    this.searchResults = [];
                }
            }, 350),

            open() {
                this.showSearchResults = true;
            },

            close() {
                this.showSearchResults = false;
            },

            select(searchResult) {
                this.showSearchResults = false;

                //Add to Cart
                let request = {
                    product_id: searchResult.id,
                    quantity: 1,
                };

                let config = {
                    headers: {
                        'X-WP-Nonce': this.nonce,
                    },
                }

                this.$store.commit('startToLoadNewItem');

                axios.post('/wp-json/modeo/v2/cart/add_to_cart', request, config)
                .then(response => {

                    let totals = {
                        subtotal: response.data.subtotal,
                        subtotalTax: response.data.subtotal_tax,
                        total: response.data.total,
                        discount: response.data.discount_total,
                        discountTax: response.data.discount_tax,
                        count: response.data.cart_product_count,
                    };

                    this.$store.commit('setTotals', totals);

                    if (response.data.status == true) {

                        let productAddedToCartData = {
                            productsAdded: 1,
                            totalCartCount: response.data.cart_product_count,
                            notificationType: 'cart-updated',
                            autoHide: true,
                            orderType: 'offer',
                            isCart: true,
                        };

                        EventBus.$emit('notify', productAddedToCartData); //TODO: Refactor Notification -component to use VueX
                    } else {

                        let messages = '';
                        if ( typeof response.data.status_messages !== 'undefined' && response.data.status_messages.length > 0 ) {
                            messages = ': ' + response.data.status_messages.join( "\n" );
                        }

                        let productAddedToCartData = {
                            message: this.$modeoL10n.add_to_cart_failed + messages,
                            notificationType: 'single-message',
                        };
                        EventBus.$emit('notify', productAddedToCartData);
                    }

                    //Update VueX State
                    let cartContents = response.data.cart_contents;
                    this.$store.commit('setCartContents', cartContents);
                })
                .catch((error) => {
                    if ( error.response ) {

                        if ( error.response.status === 403 && error.response.data.code === 'Forbidden' ) {
                            let productAddedToCartData = {
                                message: this.$modeoL10n.offer_modification_failed,
                                notificationType: 'single-message',
                            };
                            EventBus.$emit( 'notify', productAddedToCartData );
                        }

                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log( error.response.data );
                        console.log( error.response.status );
                        console.log( error.response.headers );
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log( 'Error', error.message );
                    }
                    console.log( error.config );
                });
            },
        },
    }
</script>
